const ITEMS = ["Stage faster", "Sell higher", "Scale smarter", "Win the listing", "Score every lead", "Remember every lead", "Talk instead of type"];

export const Marquee = () => (
  <section className="py-8 md:py-10 bg-ink overflow-hidden" data-testid="marquee">
    <div className="flex whitespace-nowrap animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((t, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="font-serif italic text-4xl md:text-6xl text-bone px-6 tracking-tight">
                {t}
              </span>
              <span className="text-coral text-4xl md:text-6xl">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
